import { type FlexProps } from '@ironhack/design-system2/components/flex';
import { type ReactElement } from 'react';

import { Storytelling } from '@/app/components/client';
import { type BasePageParams, getPageUrl } from '@/app/urls/url-mapping';
import {
  type DatoBlock,
  type DatoButtonBlock,
  type DatoImage,
  type DatoModuleFormat,
} from '@/lib/datocms';

export type NotFoundPageHeader = DatoBlock<{
  title: string;
  description: string;
  buttonText: string;
  image?: DatoImage;
}>;

type Props = { data: NotFoundPageHeader; params: BasePageParams } & FlexProps;

export const NotFoundPageHeader = (props: Props): ReactElement => {
  const { data, params, ...flexProps } = props;
  const { title, description, buttonText, image } = data;
  const { region, language } = params;

  const navigationLink =
    region && language && (getPageUrl('home', params) ?? '/');

  const button: [DatoButtonBlock] = [
    {
      text: buttonText,
      variant: 'primary',
      target: [
        {
          route: {
            path: navigationLink,
          },
        },
      ],
    },
  ];

  const storytellingData: Storytelling = {
    columns: [
      { image },
      {
        title,
        subtitle: description,
        button,
        flexProps: { my: 'auto' },
      },
    ],
    moduleFormat: [
      { background: 'transparent', spacingTop: '40', spacingBottom: '80' },
    ] as [DatoModuleFormat],
  };
  return <Storytelling data={storytellingData} {...flexProps} />;
};
